import { MouseEventHandler } from 'react';

import UserCard from '_common/components/UserCard/UserCard';

import cn from 'classnames';

type UserRowProps = {
  account?: Account;
  onClick?: MouseEventHandler<HTMLDivElement>;
  online?: boolean;
  testId: string;
};

const UserRow = ({ account, onClick, online, testId }: UserRowProps) => {
  return (
    <div
      className={cn('hover:bg-purple-10 active:bg-purple-20 flex cursor-pointer items-center', {
        'h-24 pl-8': account,
        'h-16 py-2 pr-2 pl-6': !account,
      })}
      onClick={onClick}
      data-testid={`${testId}-row`}
    >
      {account && (
        <UserCard
          userId={account?.id}
          online={online}
          titleStyle={{ fontWeight: 500 }}
          size="m"
          avatarStyle={{ marginRight: '1rem' }}
        />
      )}
    </div>
  );
};

export default UserRow;
